module.exports = __webpack_public_path__ + "static/media/Nadav.0bfcba4b.jpg";